var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormElementComponent as _FormElementComponent } from './angular2-schema-form-shim';
import { isSchemaButtonGroup } from './forms/schemas';
var FormElementComponent = (function (_super) {
    __extends(FormElementComponent, _super);
    function FormElementComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toast = null;
        return _this;
    }
    FormElementComponent.prototype.parseButtons = function () {
        var schema = this.formProperty.schema;
        if (schema.buttons !== undefined) {
            this.buttons = schema.buttons;
            for (var _i = 0, _a = this.buttons; _i < _a.length; _i++) {
                var button = _a[_i];
                var buttons = isSchemaButtonGroup(button) ? button.buttons : [button];
                for (var _b = 0, buttons_1 = buttons; _b < buttons_1.length; _b++) {
                    var _button = buttons_1[_b];
                    this.createButtonCallback(_button);
                }
            }
        }
    };
    return FormElementComponent;
}(_FormElementComponent));
export { FormElementComponent };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formelement.component.ts.pre-build-optimizer.js